import { createApp } from "vue";
import DOMUtils from "@utils/dom.utils";
import AppInstanceUtils from "@plugins/common/service/app.instance.utils";
import WirisHandInputModal from "@plugins/wiris-modal/components/WirisHandInputModal.vue";

const getModalContainer = (plugin) => {
  const modalContainer = document.getElementById("wiris-modal-container");
  if (modalContainer) {
    plugin.containerComponent = ModalContainerComponent;
  } else {
    const container = DOMUtils.createDivInBody({});
    const app = createApp(WirisHandInputModal);
    AppInstanceUtils.installCommonPlugin(app);
    plugin.containerComponent = app.mount(container);
    DOMUtils.replaceComponentWrapperWithComponentElement(plugin.containerComponent);
    ModalContainerComponent = plugin.containerComponent;
  }
  return plugin.containerComponent;
};

let ModalContainerComponent;

const Plugin = {
  install(app) {
    /**
     * Register Component
     */
    app.component("wiris-modal-container", WirisHandInputModal);

    const showModal = (params) => {
      const container = _getContainer(params);

      return container.show(params);
    };

    const removeModal = (params) => {
      const container = _getContainer(params);

      container.remove();
    };

    const _getContainer = (params) => {
      const root = params && params.root ? params.root : Plugin;
      return getModalContainer(root);
    };

    /**
     * Plugin API
     */
    app.config.globalProperties.$wirisModal = {
      show(params) {
        return showModal(params);
      },

      remove(params = {}) {
        removeModal(params);
      },
    };
    this.$wirisModal = app.config.globalProperties.$wirisModal;
  },
};

export default Plugin;
